import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "chat" };
const _hoisted_2 = { class: "chat__items" };
const _hoisted_3 = { class: "chat__message-container" };
const _hoisted_4 = { class: "rc-posR" };
const _hoisted_5 = ["id", "innerHTML"];
const _hoisted_6 = ["id", "innerHTML"];
import { storeToRefs } from "pinia";
import { useContext } from "@/store/context";
// Components
import ChatMessageActions from "@/experiences/ai-chat/components/ChatMessageActions.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranscriptContent',
    props: {
        response: {},
        excerptable: { type: Boolean }
    },
    setup(__props) {
        const context = useContext();
        const { isAdmin } = storeToRefs(context);
        const containerClasses = (role) => ({
            chat__message: true,
            "chat__message--user": role === "user",
            "chat__message--assistant": role === "assistant",
            "chat__message--admin": role === "assistant" && isAdmin.value
        });
        // Get plain text content for copy functionality
        const getPlainTextContent = (htmlContent) => {
            const div = document.createElement("div");
            div.innerHTML = htmlContent;
            return div.textContent || div.innerText || "";
        };
        const copyToClipboard = (content) => {
            const plainText = getPlainTextContent(content);
            if (plainText) {
                navigator.clipboard.writeText(plainText);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.messages, (message) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: message.id,
                            class: _normalizeClass(containerClasses(message.role))
                        }, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    (_ctx.excerptable && message.highlights)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            id: 'rc-excerpt-' + _ctx.response.id + '-area-' + message.id + '-highlights',
                                            class: "rc-highlight-area rc-highlight-area-content rc-RTEContent",
                                            style: { "display": "block", "width": "100%" },
                                            innerHTML: message.highlights
                                        }, null, 8, _hoisted_5))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                        id: 'rc-excerpt-' + _ctx.response.id + '-area-' + message.id,
                                        class: "rc-excerpt-area rc-RTEContent",
                                        innerHTML: message.content
                                    }, null, 8, _hoisted_6)
                                ]),
                                (message.role === 'assistant' && _unref(isAdmin))
                                    ? (_openBlock(), _createBlock(ChatMessageActions, {
                                        key: 0,
                                        reasoning: message.reasoning,
                                        onCopy: ($event) => (copyToClipboard(message.content))
                                    }, null, 8, ["reasoning", "onCopy"]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 2));
                    }), 128))
                ])
            ]));
        };
    }
});
